import { CreateUserSchema } from "~/lib/discord";
import {
  linkDiscordToUser,
  registerUserWithDiscord,
} from "~/lib/discord.server";
import { $API, $SERVER } from "~/util/Loaders";

export const registerApi = $API({
  path: "api/auth/discord",
  method: "POST",
  parser: CreateUserSchema,
})(
  $SERVER?.(async (cx) => {
    const { input, req } = cx;

    const sess = req.sess;
    // Если юзвер авторизован, привязываем дискорд
    if (sess) {
      try {
        const result = await linkDiscordToUser({
          userId: sess.user.id,
          input: input.discordUser,
        });
        return result;
      } catch (error) {
        console.error("Link Discord To User error:", error);
        return {
          t: "error" as const,
          message: "Something went wrong. Please try again.",
        };
      }
    }

    // Если нет, то создаем нового юзверя с дпривязкой к дискорду
    try {
      const result = await registerUserWithDiscord({ input });

      return result;
    } catch (error: any) {
      // ловим ошибку уникальности
      if (error?.code === "23505") {
        // PostgreSQL: unique_violation
        return {
          t: "error" as const,
          field: "login",
          message: "This login is already taken.",
        };
      }

      // другие ошибки
      console.error("Register error:", error);
      return {
        t: "error" as const,
        message: "Something went wrong. Please try again.",
      };
    }
  }),
);
